export default __webpack_public_path__ + "static/media/no-icon.4b0b9f53.png";